"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function logaritmicRetryFunction(params) {
    // this factor will be used to calculate log multiplier, using this multiplier
    // the delay will be exactly the specified at 10th retry
    const retryAt = 10;
    const factor = (params.delayAt10thRetryMs - params.initialDelayMs) / Math.log(retryAt);
    return (retryCount) => {
        return params.initialDelayMs + Math.log(retryCount) * factor;
    };
}
exports.logaritmicRetryFunction = logaritmicRetryFunction;
//# sourceMappingURL=logaritmic-retry-function.js.map